
import { useEffect, type ReactNode } from "react";
import { useThemeStore } from "@/stores";

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * ThemeProvider handles DOM side effects for theme changes.
 * It subscribes to the Zustand theme store and applies the
 * dark class to the document element.
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  const { theme, isHydrated } = useThemeStore();

  useEffect(() => {
    // Only apply theme after hydration to prevent flash
    if (!isHydrated) return;

    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme, isHydrated]);

  return <>{children}</>;
}

export default ThemeProvider;
